import CompletedMeetings from '@/components/meetings/completed-meetings';

export function CompletedMeetingsPage() {
  return <CompletedMeetings />;
}
